import { Drawer } from '@mantine/core';
import { CreatorChallenge } from '../../../../types/challenges';
import { dayjs } from '../../../../utils/dayjs-utils';
import {
  getChallengeProgressLabel,
  getChallengeRewardTypeLabel,
  getChallengeTitle,
  isChallengeRewardClaimable,
} from '../../../../utils/challenge-utils';
import ChallengeStatusTag from './ChallengeStatusTag';
import styles from './allChallenges.module.css';

type ActiveChallengeDrawerProps = {
  challenge: CreatorChallenge | null;
  defaultCurrency: string;
  onClose: () => void;
  onClaimReward: (challenge: CreatorChallenge) => void;
};

const formatEndDateValue = (endDate: string | null) => (endDate ? dayjs(endDate).format('D MMM, YYYY') : '-');

export default function ActiveChallengeDrawer({
  challenge,
  defaultCurrency,
  onClose,
  onClaimReward,
}: ActiveChallengeDrawerProps) {
  const isClaimable = challenge ? isChallengeRewardClaimable(challenge) : false;

  return (
    <Drawer
      opened={Boolean(challenge)}
      onClose={onClose}
      position="bottom"
      title="Challenge Details"
      padding={0}
      size="auto"
      zIndex={1100}
      overlayProps={{ opacity: 0.4, color: '#000' }}
      styles={{
        content: {
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        },
        header: {
          justifyContent: 'center',
          padding: 16,
          borderBottom: '1px solid #eaecf0',
        },
        title: {
          fontSize: 14,
          fontWeight: 500,
          color: '#353535',
          textAlign: 'center',
          width: '100%',
        },
        close: {
          position: 'absolute',
          right: 14,
          top: 14,
        },
        body: {
          padding: '16px 0',
        },
      }}
    >
      {challenge && (
        <div className={styles.drawerContent}>
          <div className={styles.drawerRow}>
            <p className={styles.drawerLabel}>Challenge</p>
            <p className={styles.drawerValue}>{getChallengeTitle(challenge, defaultCurrency)}</p>
          </div>
          <div className={styles.drawerRow}>
            <p className={styles.drawerLabel}>Reward Type</p>
            <p className={styles.drawerValue}>{getChallengeRewardTypeLabel(challenge)}</p>
          </div>
          <div className={styles.drawerRow}>
            <p className={styles.drawerLabel}>Progress</p>
            <p className={styles.drawerValue}>{getChallengeProgressLabel(challenge)}</p>
          </div>
          <div className={styles.drawerRow}>
            <p className={styles.drawerLabel}>Ends on</p>
            <p className={styles.drawerValue}>{formatEndDateValue(challenge.endDate)}</p>
          </div>
          {isClaimable && (
            <div className={styles.drawerStatusRow}>
              <p className={styles.drawerLabel}>Reward Status</p>
              <ChallengeStatusTag
                status="claim"
                onClaim={() => {
                  onClose();
                  onClaimReward(challenge);
                }}
              />
            </div>
          )}
        </div>
      )}
    </Drawer>
  );
}
